import { __makeTemplateObject } from "tslib";
import styled from "../../redoc-lib/src/styled-components";
import { ContentPanel } from "./ContentPanel";
import { PanelBody } from "./PanelBody";
export var ScrollableContentPanel = styled(ContentPanel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    overflow-x: auto;\n  }\n"], ["\n  ", " {\n    overflow-x: auto;\n  }\n"])), PanelBody);
var templateObject_1;